module.exports = __webpack_public_path__ + "img/loginbg1.af064d0d.png";